export default __webpack_public_path__ + "static/media/signal.9b3eb38c.svg";